import React from 'react';
import { gikClassPrefix } from '@gik/core/constants';
import classnames from 'classnames';
import { BaseBoneProps } from '@gik/ui/SkeletonLoader/Bones/BaseBone';

const blockName = `${gikClassPrefix}-frame-bone`;

export interface FrameBoneProps extends React.PropsWithChildren<BaseBoneProps> {}

export default function FrameBone({ className, children }: FrameBoneProps) {
  const blockClasses = classnames([blockName, className || '']);

  return (
    <div className={blockClasses}>
      <div>{children}</div>
    </div>
  );
}
